import { render, staticRenderFns } from "./Defile.vue?vue&type=template&id=b433a5aa&scoped=true"
import script from "./Defile.vue?vue&type=script&lang=js"
export * from "./Defile.vue?vue&type=script&lang=js"
import style0 from "./Defile.vue?vue&type=style&index=0&id=b433a5aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b433a5aa",
  null
  
)

export default component.exports